export const webStorePtwClearAuth = () => {
  localStorage.removeItem("PtwLogon");
  sessionStorage.removeItem("PtwLogon");
};
